import ReactMarkdown from 'react-markdown';
import { Typography } from '@arionbanki/arionui';
import { ProgressBar } from 'components';
import { RiskQResultsForm } from './RiskqResultsForm';
import { useRiskqResults } from './useRiskqResults';

export function RiskqResults() {
	const p = useRiskqResults();
	return (
		<ProgressBar page="riskq-results">
			<Typography TagName="h3" className="mb-5">
				{p.t(`${p.flowType}_${p.entityType}_title`, 'riskq_results')}
			</Typography>
			<ReactMarkdown className="my-3">
				{p.t(`${p.flowType}_${p.entityType}_main_description`, 'riskq_results')}
			</ReactMarkdown>
			<RiskQResultsForm {...p} />
		</ProgressBar>
	);
}
